<template>
    <div v-show="visible">
        <AllCommentsModal v-if="planoId && modelId && elementId" :commentData="commentData" :appId="2" @closeModal="close"></AllCommentsModal>
    </div>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import AllCommentsModal from "@/components/CommentBloc/AllCommentsModal";
import { mapActions } from "vuex";
import { bus } from "@/main";
import { applyTipCommentOnElement, removeCommentTipCommentOnElement } from "@/plano/utils";

let editCommentWidget;
window.editComment = function editComment(data, onValidate, onCancel) {
    editCommentWidget.modelId = data.element.modelId();
    editCommentWidget.elementId = data.element.id;
    editCommentWidget.visible = true;
    editCommentWidget.onValidate = onValidate;
    editCommentWidget.onCancel = onCancel;
    editCommentWidget.commentText = data.commentText;
    // Une fonction est utilisée car Vuejs modifie la structure des données d'Henri
    // (ex: List -> Array) créant un disfonctionnement
    editCommentWidget.el = () => data.element;
};

export default {
    data() {
        return {
            visible: false,
            onValidate: undefined,
            onCancel: undefined,
            el: undefined,
            elementId: undefined,
            commentData: undefined,
            commentText: undefined,
            haveComments: false,
            modelId: undefined
        };
    },
    watch: {
        visible(isVisible) {
            if (isVisible) {
                const { planoId, elementId, modelId } = this;
                this.commentData = { plano: { id: planoId }, componentIdExternal: elementId, component: { id: modelId } };
            } else {
                this.flushComment();
                this.flushComponents();
            }
        }
    },
    props: {
        planoId: {
            type: Number
        }
    },
    created() {
        editCommentWidget = this;
        bus.$on("HAVE_COMMENTS", this.hasCommentsListener);
        bus.$on("HAVE_NO_COMMENTS", this.hasNoCommentsListener);
    },
    components: {
        ModalBase,
        AllCommentsModal
    },
    methods: {
        ...mapActions("comment", ["flushComment"]),
        validate() {
            if (this.haveComments && JSON.stringify(this.commentData)) {
                this.onValidate({
                    commentText: JSON.stringify(this.commentData)
                });
            }
            this.visible = false;
        },
        close() {
            if (!this.haveComments) removeCommentTipCommentOnElement(this.el());
            this.onCancel();
            this.visible = false;
        },
        hasCommentsListener() {
            this.haveComments = true;
            applyTipCommentOnElement(this.el());
        },
        hasNoCommentsListener() {
            this.haveComments = false;
            removeCommentTipCommentOnElement(this.el());
        },
        flushComponents() {
            this.onValidate = undefined;
            this.onCancel = undefined;
            this.el = undefined;
            this.elementId = undefined;
            this.commentData = undefined;
            this.commentText = undefined;
            this.haveComments = false;
            this.modelId = undefined;
        }
    },
    beforeDestroy() {
        editCommentWidget = undefined;
        bus.$off("HAVE_COMMENTS", this.hasCommentsListener);
        bus.$off("HAVE_NO_COMMENTS", this.hasNoCommentsListener);
    }
};
</script>

<style lang="scss" scoped>
section {
    min-width: 300px;
    margin: 20px 0px;

    label {
        vertical-align: top;
    }

    textarea {
        width: 500px;
    }
}
</style>



// WEBPACK FOOTER //
// edit_comment.vue?191e7086